import type { GroupBookingData, Occupancy } from '@/scopes/account/group-responsible/domain/types'
import type { GroupBookingAPIResponse } from '@/scopes/account/group-responsible/infrastructure/types'
import { getParticipantName } from './utils'

function mapOccupancy(assigned: number, max: number): Occupancy {
  return {
    occupied: assigned,
    max,
  }
}

export function mapRooms(
  childBookings: GroupBookingAPIResponse['data']['childBookings'],
): GroupBookingData['rooms'] {
  return childBookings
    .map((room) => {
      const accommodationService = room.services.find(service => service.typeOfService === 'Accommodation')

      const activeParticipants = room.participants
      const hasCancelledParticipants = room.cancelledParticipants.length > 0
      const hasOverCapacity = activeParticipants.length > room.maxParticipants
      const occupancy = mapOccupancy(activeParticipants.length, room.maxParticipants)
      const occupancyText = `${occupancy.occupied}/${occupancy.max}`
      const roomId = room.bookingNumber.toString()

      return {
        id: roomId,
        name: roomId,
        type: room.roomType,
        occupancy,
        occupancyText,
        accommodationName: accommodationService?.name || '',
        accommodationStartDate: accommodationService?.startDate || '',
        accommodationEndDate: accommodationService?.endDate || '',
        participantsInfo: activeParticipants.map(participant => ({
          id: participant.participantId.toString(),
          bookingCustomerId: participant.bookingCustomerId,
          name: getParticipantName(participant.firstName, participant.lastName),
          isAssigned: participant.used,
        })),
        needsAction: hasCancelledParticipants || hasOverCapacity,
        pinCode: room.pinCode,
      }
    })
    .reduce((acc, room) => {
      acc[room.id] = room
      return acc
    }, {} as GroupBookingData['rooms'])
}
